import React from "react";
import UserLayout from "../Layouts/UserLayout";

const Imfw = () => {
  return (
    <UserLayout>
      <div>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate rem
        tempora laboriosam exercitationem, dolorem ducimus! Distinctio minus
        esse labore voluptates cumque quisquam quam natus nostrum veniam saepe
        neque praesentium nesciunt, ipsam sit animi magni quod quibusdam, eos
        rem iure assumenda voluptate unde quae quasi! Animi temporibus iure sed
        hic sapiente? Impedit perferendis tempore quasi, possimus odit id
        mollitia dignissimos commodi non ullam ut architecto repellendus natus
        quia voluptates labore eligendi iure adipisci voluptatibus ad, ratione,
        cumque aspernatur rerum. Assumenda ut minus cumque excepturi porro
        quaerat voluptates consectetur aliquam, sapiente ipsam velit autem
        molestiae quisquam mollitia rerum, sequi repudiandae id optio.
      </div>
    </UserLayout>
  );
};

export default Imfw;
